export const ELM_COLOR_PICKER_OPTIONS = {
  defaultColor: '#aa0000',
  presetColors: [] // Temp sample colors
};
